import React from 'react';

const CombatSports = () => {
  const cards = [
    {
      image: "https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?auto=format&fit=crop&w=900&q=80",
      tag: "Boxing",
      title: "Big Fight Night Highlights",
      description: "Recap knockdowns, tactics and post-fight reactions from the latest main events.",
      link: "https://www.dazn.com/en-IN/welcome/en-IN/welcome",
      linkText: "Watch Boxing Nights →"
    },
    {
      image: "https://images.unsplash.com/photo-1517438322307-e67111335449?auto=format&fit=crop&w=900&q=80",
      tag: "MMA",
      title: "MMA Main Card Breakdowns",
      description: "Previews, rankings and matchup analysis for upcoming MMA events.",
      link: "https://www.dazn.com/en-IN/welcome/en-IN/welcome",
      linkText: "View Fight Cards →"
    },
    {
      image: "https://images.unsplash.com/photo-1620123646588-b9117246a9d0?q=80&w=1170&auto=format&fit=crop",
      tag: "Kickboxing",
      title: "Stand-Up Wars Return",
      description: "High-pace striking showcases and tournament cards for pure action fans.",
      link: "https://www.dazn.com/en-IN/welcome/en-IN/welcome",
      linkText: "See Events →"
    }
  ];

  return (
    <section className="section" id="combat-zone">
      <div className="section-title">Combat Sports Hub (Boxing • MMA • Kickboxing)</div>
      <div className="section-sub">Many of these events are available live or on demand through our streaming partners in the US and other territories, especially boxing and fight nights.</div>

      <div className="grid-3">
        {cards.map((card, index) => (
          <div key={index} className="card">
            <img src={card.image} alt={card.tag} />
            <div className="card-body">
              <div className="card-tag">{card.tag}</div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
              <a href={card.link}>{card.linkText}</a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CombatSports;
